import React, { memo, MouseEvent } from "react"

import { Tab } from "./Contents"

interface Props {
  tab: Tab
  setTab: React.Dispatch<React.SetStateAction<Tab>>
  showViewerTab: boolean
  onShortFormClick?: () => void
}

function Tabs({ tab, setTab, showViewerTab, onShortFormClick }: Props) {
  return (
    <div className="tabB">
      {showViewerTab && (
        <a
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            setTab("시청자")
          }}
          className={tab === "시청자" ? "on" : ""}
          title="시청자"
        >
          시청자
        </a>
      )}
      <a
        onClick={(e: MouseEvent) => {
          e.preventDefault()
          setTab("숏폼 / AI 요약")
          onShortFormClick?.()
        }}
        className={tab === "숏폼 / AI 요약" ? "on" : ""}
        title="숏폼 / AI 요약"
      >
        숏폼 / AI 요약
      </a>
    </div>
  )
}

export default memo(Tabs)
